// extracted by mini-css-extract-plugin
export default {"strip":"bV6+E","root":"FdHYv","compareLink":"_6y4tR","compareButton":"VVFMN","leftToRight":"svG99"};